import React from "react";

const SectionHeading = ({ title, icon, link, linkTitle, classes = "" , titleClass="" }) => {
  return (
    <div className={`flex items-center justify-between ${classes}`}>
      <div className="flex items-center gap-2">
        {icon && <span className="mt-px">{icon}</span>}
        <h4
          className={`${titleClass || "text-2xl font-bold leading-7 text-gray-900 md:text-xl xl:text-2xl font-cmr"}`}
        >
          {title}
        </h4>
      </div>
      {link && (
        <a href={link} className="text-sm font-medium text-gold-300">
          {linkTitle || "View All"}
        </a>
      )}
    </div>
  );
};

export default SectionHeading;
